export default __webpack_public_path__ + "static/megabuyte-d2017dc3aa4e7840a5255306825a5dd2.png";